import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {AddressForm} from "../../../../../website/authenticated/pages/account/components/address/AddressForm";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {apiCreateAddress} from "../../../../../../client/state/UserAddressStore";


export class AddAddressComponent extends UI.Element {
    render() {
        return <AddressForm ref="form"/>;
    }

    isValid() {
        return true;
    }

    @wrapInSpinner
    async getAddress() {
        if (!this.form.validateInputs()) {
            return null;
        }
        try {
            return await apiCreateAddress(this.form.getValues());
        } catch (error) {
            if (error?.fields) {
                this.form.displayFieldErrors(error);
            }
            return null;
        }
    }
}
